import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/site";
import { Check } from "lucide-react";

const BENEFITS = [
  "Training without nutrition rarely gets you there — the two work together.",
  "Simple, realistic guidance built around your life, not a fad diet.",
  "Fuel for strong bones, muscles and steady energy through the day.",
  "Habits for longevity — feeling young and capable at any age.",
];

export const Nutrition = () => (
  <section id="nutrition" className="py-24 md:py-32 bg-[#020617]">
    <div className="mx-auto max-w-7xl px-5 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <div className="relative rounded-[2.5rem] overflow-hidden border border-white/10 h-80 md:h-[520px] group">
          <img src={IMAGES.nutrition} alt="Fresh prepared healthy meals" className="img-desat w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#020617]/60 to-transparent" />
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <span className="font-mono-label text-[11px] text-[#FACC15]">Nutrition & guidance</span>
        <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-4">
          The other <span className="text-[#FACC15]">half</span> of the transformation.
        </h2>
        <p className="text-[#94A3B8] mt-5 text-base md:text-lg leading-relaxed max-w-xl">
          Real, lasting change is built in the kitchen as much as the workout. I'll help you
          understand what your body needs — no gimmicks, just guidance you can actually keep to.
        </p>
        <ul className="mt-8 space-y-4">
          {BENEFITS.map((b, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <li className="flex items-start gap-3" data-testid={`nutrition-benefit-${i}`}>
                <span className="mt-0.5 shrink-0 w-6 h-6 rounded-full bg-[#FACC15] text-[#020617] flex items-center justify-center">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span className="text-[#F8FAFC]/90 text-base">{b}</span>
              </li>
            </Reveal>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
